import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
    body, html {
        height: 100vh;
        scrollbar-color: transparent transparent;
    }
    /* width */
    ::-webkit-scrollbar {
        width: 8px;
        background: transparent;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: transparent;
        border-radius: 10px;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: gray;
        border-radius: 10px;
    }
`;
